import * as React from "react";
import { getSrc, getCellClassName, getRowClassName, getIconClassName, getCellValue, getTitle } from "_helpers";
import { useLocation } from "react-router-dom";
import { TableBody, TableCell, TableRow } from '@mui/material';
import { BatteryIndicatorHorizontal } from "_components/battery";


export const Tbody = ({data, headers, stickyFirstColumn}) => {
    const { pathname } = useLocation();

    const handleClickIcon = (h, row) => {
        if (h.type === 'action' && h.action){
            h.action(row)
        }
    };
    // Détection headers groupés ou plats
    const isGroupedHeaders = (headers) =>
        headers.length > 0 && headers[0].children !== undefined;

    // On aplati la structure si grouped
    const flatHeaders = isGroupedHeaders(headers)
        ? headers.flatMap((g) => g.children)
        : headers;

    const visibleColCount = flatHeaders.filter((h) => h.visible).length;
    

    return (
        <TableBody>
            {data.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={visibleColCount} align="center">
                        Aucune donnée disponible
                    </TableCell>
                </TableRow>
            ) : (
            data.map((row, index) => (
                <TableRow hover key={index} className={getRowClassName(row, pathname)}>
                    {flatHeaders.map((h, index) => {
                        if (!h.visible) return null;

                        const iconSrc = h.icon && h.icon !== 'batteryIndicator' ? getSrc(h, row, pathname) : null;

                        // style spécifique pour la 1ère colonne sticky
                        const stickyStyle =
                            stickyFirstColumn && index === 0
                                ? {
                                        position: "sticky",
                                        left: 0,
                                        backgroundColor: "inherit",
                                        zIndex: 3, // plus élevé pour être au-dessus des autres cellules
                                        borderRight: "1px solid rgba(224, 224, 224, 1)", // fine bordure droite
                                        boxShadow: "4px 0 6px -4px rgba(0,0,0,0.2)",
                                    }
                                : {};

                        return (
                        <TableCell
                            className={getCellClassName(index, h, row, pathname)}
                            align="left"
                            key={index}
                            sx={stickyStyle}
                        >
                            {/* Affichage de l'icône si présente et valide */}
                            {h.icon && h.icon !== 'batteryIndicator' && iconSrc && (
                                <img
                                    className={getIconClassName(h)}
                                    src={iconSrc}
                                    alt={h.title ?? ''}
                                    title={getTitle(h, row)}
                                    onClick={() => handleClickIcon(h, row)}
                                />
                            )}

                            {/* Composant spécifique pour la batterie */}
                            {h.icon === 'batteryIndicator' && (
                                <BatteryIndicatorHorizontal
                                    percentage={row.SOC}
                                    height="20px"
                                    mb="0"
                                />
                            )}

                            {/* Valeur de cellule */}
                            {getCellValue(h, pathname, row[h.key], row)}
                        </TableCell>
                        );
                    })}
                    </TableRow>
            )))}
        </TableBody>
    )
}